export const insurance = () => {
  return [
    { text: `     11. INSURANCE`, bold: true, style: 'p' },

    {
      text: [
        { text: `     11.1.`, bold: true },
        { text: ` Independent Contractor for the purposes of its own business shall have and maintain at Independent Contractor’s sole cost and expense all insurance required by and consistent with the limits of such coverage, except as provided herein if greater, that will indemnify and save harmless Independent Contractor, Company and its Customers, from any and all liability, by reason of any accidents, injuries, or damages of any kind that may result from the operation, or use, of Independent Contractor’s vehicle and/or Equipment from any other actions or conduct of Independent Contractor in the performance of TICA Services hereunder. Specifically, Independent Contractor shall obtain and keep in full force during the term of this TICA:` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     11.1.1.`, bold: true },
        { text: ` Automobile Liability Insurance. Automobile liability insurance to protect and defend Company against public liability claims for injury, death, property damage or other loss while providing services under this TICA. Independent Contractor shall maintain, at a minimum and at its sole cost and expense, split liability limits of not less than One Million Dollars ($1,000,000) for injury or death to any person and One Million Dollars ($1,000,000) for injury or death to any persons in any one occurrence. Such coverage shall be primary to any other insurance that may be available from Company, and Independent Contractor shall include both Non-owned and Hired Auto Liability. Independent Contractor shall be responsible for any loss or damage in excess of policy limits. Coverage shall be in the form of a business auto or trucker’s policy when Independent Contractor operates in a jurisdiction that mandates that Independent Contractor procure a motor carrier license;` }
      ],
      style: 'p',
      margin: [40, 0, 0, 0],
    },

    {
      text: [
        { text: `     11.1.2.`, bold: true },
        { text: ` Cargo Insurance. Cargo insurance coverage with minimum coverage limits of not less than $100,000.00 per occurrence. The contractor shall be responsible for any and all cargo claims that are a result of mechanical failure.` }
      ],
      style: 'p',
      margin: [40, 0, 0, 0],
    },

    {
      text: [
        { text: `     11.1.3.`, bold: true },
        { text: ` Worker’s Compensation Insurance. Worker’s Compensation insurance policy or an occupational accident policy that covers any employees of Independent Contractor performing TICA Services and satisfies the applicable state laws.` }
      ],
      style: 'p',
      margin: [40, 0, 0, 0],
    },

    {
      text: [
        { text: `     11.1.4.`, bold: true },
        { text: ` Non-Owned & Hired Physical Damage. Independent Contractor shall be responsible and pay for any collision, fire, theft, and comprehensive insurance coverage on and for its Equipment, as well as any of Company’s own Equipment operated by Independent Contractor. Company shall not be liable for or obligated to pay or reimburse Independent Contractor for such insurance coverage or from any loss or damage to Independent Contractor’s Equipment. The costs of towing, storage, emergency repairs or actions necessary to protect the Equipment or cargo shall be the responsibility of Independent Contractor, and if these expenses are paid by Company, Independent Contractor hereby agrees that any such payment may be deducted from Independent Contractor’s Settlement Payment as hereinafter described. Independent Contractor shall be responsible for any and all physical damage to any dump body, trailer or trailer set furnished by Company while in the Independent Contractor’s care, custody and control. Independent Contractor is required to provide evidence of Non-Owned & Hired Physical Damage insurance coverage in the amounts shown below for the applicable Equipment. Independent Contractor’s policy shall name Company as the loss payee. In the event of collision, fire, theft or any damage to furnished Equipment, Independent Contractor shall notify Company immediately.` }
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: `     11.2.`, bold: true },
        { text: ` The Company shall be named as an “Additional Insured” on all policies issued hereunder, except Workers’ Compensation coverage, and shall provide that:` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     11.2.1.`, bold: true },
        { text: ` Company shall not be obligated to pay premiums for any such insurance; 11.2.2 Such insurance shall be primary and non-contributory with respect to all insured; 11.2.3 Such insurance shall be applicable separately to each insured, and shall cover claims, suits, actions or proceedings by each insured against any other insured.` }
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: `     11.3.`, bold: true },
        { text: ` Any policy or certificate of insurance evidencing such insurance shall contain a clause that the insurer will not cancel or change coverage of the insurance without first giving Company thirty (30) days’ prior written notice, and that the Insurer will be liable to Company for any and all damages resulting from Insurer’s failure to give such notice.` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     11.4.`, bold: true },
        { text: ` Independent Contractor’s insurance policies shall provide for waiver of underwriter’s subrogation rights against Company, its directors, officers, employees, stockholders, subsidiaries and affiliates.` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     11.5.`, bold: true },
        { text: ` Independent Contractor hereby agrees to furnish to Company written evidence obtained from Independent Contractor’s insurance company or agent showing that all insurance coverage required above has been procured from a company with an AM Best rating of A-VII or better, is being properly maintained, and the premiums therefor are paid, specifying the name of the insurance company, the policy number, the expiration date, and the limits of liability.` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     11.6.`, bold: true },
        { text: ` It is expressly understood that Company does not represent that the types or minimum limits of the insurance set forth herein are adequate to protect the Independent Contractor’s own business interests. For any claims in excess of policy limits, Independent Contractor agrees to indemnify, save harmless and undertake the defense of the Company. Deductible amounts under the foregoing policies shall also be paid by Independent Contractor in the ordinary course of its business.` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     11.7.`, bold: true },
        { text: ` In the event of any loss, damage, occurrence or claim arising from Independent Contractor's performance of this TICA, insurance policies provided by the Independent Contractor under this TICA shall provide primary coverage for such loss, damage, occurrence or claim. Coverage by insurance policies maintained by the Company shall provide excess coverage, but not until and unless the limits of Independent Contractor's primary policies have been exhausted by the way of judgment or settlement.` }
      ],
      style: 'p',
    },
  ]
}